import omitBy from 'lodash/omitBy'
import type { CompanyDocument, OptionsDocument } from 'paintscout'
import isNull from 'lodash/isNull'
import { uuid } from '../../util'

export function createCompany(company?: Partial<CompanyDocument>, options?: OptionsDocument): CompanyDocument {
  const sanitized = omitBy(company, isNull)
  return {
    _id: uuid(),
    _rev: null,
    _deleted: null,
    name: '',
    address: '',
    city:
      options?.options?.defaultCompanyDetails?.active && options?.options?.defaultCompanyDetails?.city
        ? options?.options?.defaultCompanyDetails?.city
        : '',
    province:
      options?.options?.defaultCompanyDetails?.active && options?.options?.defaultCompanyDetails?.prov
        ? options?.options?.defaultCompanyDetails?.prov
        : '',
    postal: '',
    phone_number: '',
    phone_ext: '',
    email: '',
    created: Date.now(),
    updated: Date.now(),
    ...sanitized,
    type: 'Company'
  }
}
